export const reportError = (err) => {
  console && console.error && console.error(err.stack);
};
